// Returns the API base URL for calling the PHP backend.
//
// During SSR we call the backend directly through the internal cluster Service
// (apiUrlInsideDocker), so the request stays east-west inside the cluster
// instead of looping back out through Cloudflare and the public load balancer.
// On the client we use the public apiUrl, because the browser cannot resolve
// the internal cluster DNS name.
export function useApiBaseUrl(): string {
    const config = useRuntimeConfig()

    return (process.client ? config.public.apiUrl : config.public.apiUrlInsideDocker) as string
}

// Endpoints already implemented by pilulka.eshop.go.api.
export const GO_API_ENDPOINTS = ['/api/v2/pwa/router', '/api/v3/product/list']

// Returns the pilulka.eshop.go.api base URL when NUXT_PUBLIC_GO_API_URL is set
// (only some beta slots), otherwise the regular PHP backend URL. Use only for
// GO_API_ENDPOINTS. Same SSR/client split as useApiBaseUrl().
export function useGoApiBaseUrl(): string {
    const config = useRuntimeConfig()

    return resolveGoApiBaseUrl(config.public) || useApiBaseUrl()
}

// Go API base URL for the current side (internal cluster Service during SSR,
// public URL on the client), or '' when the Go API is not configured.
export function resolveGoApiBaseUrl(publicConfig: { goApiUrl?: unknown; goApiUrlInsideDocker?: unknown }): string {
    const goApiUrl = publicConfig.goApiUrl as string
    if (!goApiUrl) {
        return ''
    }

    return process.client ? goApiUrl : (publicConfig.goApiUrlInsideDocker as string) || goApiUrl
}
